// src/components/Header.jsx
import React, { useEffect, useRef, useState } from "react";

function formatTodayInMarathi() {
  const today = new Date();
  const options = {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  };
  return today.toLocaleDateString("mr-IN", options);
}

const Header = () => {
  const headerRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isPinned, setIsPinned] = useState(false);

  // entrance animation (left/right slide in)
  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 50);
    return () => clearTimeout(timer);
  }, []);

  // scroll handling
  useEffect(() => {
    const handleScroll = () => {
      if (!headerRef.current) return;

      const headerHeight = headerRef.current.offsetHeight || 1;
      const scrollY = window.scrollY;

      let progress = scrollY / headerHeight;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      setScrollProgress(progress);

      // pin after we've scrolled past header height
      setIsPinned(scrollY >= headerHeight);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  useEffect(() => {
  if (isPinned) {
    document.body.classList.add("header-pinned");
  } else {
    document.body.classList.remove("header-pinned");
  }

  // cleanup on unmount
  return () => {
    document.body.classList.remove("header-pinned");
  };
}, [isPinned]);
  // when near the bottom of hero OR pinned => use logo2
  const showLogo2 = scrollProgress >= 0.9 || isPinned;

  // classes for header
  const headerClassName = [
    "app-header",
    "app-header-animated",
    isLoaded ? "is-loaded" : "",
    isPinned ? "is-pinned" : "",
  ]
    .filter(Boolean)
    .join(" ");

  // side images: enter on load, exit once we start scrolling a bit
  const leftSideClass = [
    "header-side",
    "header-side-left",
    isLoaded ? "enter" : "",
    scrollProgress > 0.25 ? "exit" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const rightSideClass = [
    "header-side",
    "header-side-right",
    isLoaded ? "enter" : "",
    scrollProgress > 0.25 ? "exit" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <header ref={headerRef} className={headerClassName}>
      {/* Background image */}
      <div className="header-bg-layer">
        <img
          src="/files/bg.png"   // 🔁 your background image
          alt=""
          className="header-bg-img"
        />
      </div>

      {/* Left side PNG */}
      <img
        src="/files/leftSide.png"        // 🔁 your left PNG
        alt=""
        className={leftSideClass}
      />

      {/* Right side PNG */}
      <img
        src="/files/rightSide.png"       // 🔁 your right PNG
        alt=""
        className={rightSideClass}
      />

      {/* Center logo (logo1 → logo2) */}
      <div
        className="header-logo-wrapper"
        style={{
          // always horizontally & vertically centered
          transform: `translate(-50%, -50%) scale(${isPinned ? 0.8 : 1})`,
        }}
      >
        <img
          src={showLogo2 ? "/files/logo2.png" : "/files/logo1.png"}   // 🔁 your logos
          alt="बोलबाला TV"
          className="header-logo-img"
        />
      </div>

      {/* Date (always visible) */}
      <div className="app-header-date">{formatTodayInMarathi()}</div>
    </header>
  );
};

export default Header;
